export const TourCompletionStatus = {
  COMPLETE: 'COMPLETE',
  INCOMPLETE: 'INCOMPLETE',
  SKIPPED: 'SKIPPED'
};